import React, { useEffect, useRef, useState } from "react";

export default function NumberCell({ value, column, readOnly, onCommit }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? "");
  const ref = useRef(null);

  useEffect(() => {
    setDraft(value ?? "");
  }, [value]);

  useEffect(() => {
    if (editing) ref.current?.focus();
  }, [editing]);

  const commit = () => {
    setEditing(false);
    if (draft === "" || draft === null) {
      if (value !== null && value !== undefined) onCommit(null);
      return;
    }
    const n = Number(draft);
    if (!Number.isFinite(n)) {
      setDraft(value ?? "");
      return;
    }
    if (n !== Number(value)) onCommit(n);
  };

  const unit = column?.settings?.unit;
  const decimals = column?.settings?.decimals ?? 0;

  if (editing && !readOnly) {
    return (
      <input
        ref={ref}
        type="number"
        className="cell-input"
        value={draft ?? ""}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") setEditing(false);
        }}
      />
    );
  }

  const display =
    value === null || value === undefined || value === ""
      ? null
      : Number(value).toFixed(decimals);

  return (
    <div
      className={`cell-display number ${readOnly ? "read-only" : ""}`}
      onClick={() => !readOnly && setEditing(true)}
    >
      {display !== null ? (
        <>
          {display} {unit ? <span className="unit">{unit}</span> : null}
        </>
      ) : (
        <span className="placeholder">—</span>
      )}
    </div>
  );
}
